import type { Components, Theme } from "@mui/material/styles";

// The icon-size scale lives in `theme.iconSize` (options/index.ts); the keyword
// sizes derive from it so the `fontSize` prop and `theme.iconSize.*` (in styled
// blocks) resolve to the same value. `small`/`medium`/`large` override MUI's
// defaults via their slots; the custom `xs` rides `root` + `ownerState` since
// MUI ships no `fontSizeXs` slot.
//
// `sm`/`md` currently equal MUI's own defaults (20px/24px), so those two slots
// are no-ops today. They are kept deliberately: the point is that the keyword
// (`fontSize="small"`) and the token (`theme.iconSize.sm`) resolve through the
// same source, so they can never drift. Don't "clean up" the matching slots.
export const MuiSvgIcon: Components<Theme>["MuiSvgIcon"] = {
  styleOverrides: {
    fontSizeSmall: ({ theme }) => ({ fontSize: theme.iconSize.sm }),
    fontSizeMedium: ({ theme }) => ({ fontSize: theme.iconSize.md }),
    fontSizeLarge: ({ theme }) => ({ fontSize: theme.iconSize.lg }),
    root: ({ ownerState, theme }) =>
      ownerState.fontSize === "xs" ? { fontSize: theme.iconSize.xs } : {},
  },
};
